import { useNavigate } from 'react-router';

import DocumentIcon from '~domains/partner-application/shared/assets/icons/document.svg?react';
import { StatusScreenContent } from '~domains/partner-application/shared/ui/status-screen-content';

import { ROUTES } from '~shared/config/routes';
import { ScreenHeader, Screen } from '~shared/ui/screen';

type ApprovedScreenProps = {
  applicationId: string;
};

export const ApprovedScreen = ({ applicationId }: ApprovedScreenProps) => {
  const navigate = useNavigate();

  return (
    <Screen header={<ScreenHeader singleLogoAlign="left" />}>
      <StatusScreenContent
        icon={<DocumentIcon />}
        title="Approved, boss!"
        description={
          <>Sign now and you&#39;re officially a&nbsp;Skyro partner.</>
        }
        action={{
          label: "Let's go!",
          onClick: () => {
            navigate(ROUTES.partner.applicationSign.link(applicationId));
          },
        }}
      />
    </Screen>
  );
};
